import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './lib/auth';
import { ThemeProvider } from './lib/theme';
import { ErrorBoundary } from './components/error/ErrorBoundary';
import { LoadingFallback } from './components/ui/LoadingFallback';
import App from './App';
import './lib/i18n';
import './index.css';

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(error => {
      console.warn('Service worker registration failed:', error);
    });
  });
}

const router = createBrowserRouter([
  {
    path: '/*',
    element: (
      <React.StrictMode>
        <ErrorBoundary>
          <Suspense fallback={<LoadingFallback />}>
            <HelmetProvider>
              <ThemeProvider>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </ThemeProvider>
            </HelmetProvider>
          </Suspense>
        </ErrorBoundary>
      </React.StrictMode>
    )
  }
], {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(<RouterProvider router={router} />);